(function () {
  document.addEventListener('shopify:section:load', (e) => {
    // Get the loaded section
    const section = JSON.parse(
      e.target.getAttribute('data-shopify-editor-section')
    );
    const sectionElement = e.target.querySelector('.switch-slider');
    const swiperElements = e.target.querySelectorAll('.swiper-switch-slider');
    const switchBlocks = e.target.querySelectorAll('.switch-block');
    if (sectionElement) {
      const switchButtons = sectionElement.querySelectorAll(
        '.switch-btns .switch-btn'
      );

      // Swiper autoplay settings
      let autoplaySettings;
      if (sectionElement) {
        let autoplayVal = JSON.parse(
          sectionElement.getAttribute('data-autoplay').toLowerCase()
        );
        if (autoplayVal === true) {
          autoplaySettings = {
            delay: 5000,
          };
        } else {
          autoplaySettings = false;
        }
      }

      const swiper = (element) => {
        const swiperNav = {
          next: element.querySelector('.swiper-button-next'),
          prev: element.querySelector('.swiper-button-prev'),
        };
        const swiper = new Swiper(element, {
          direction: 'horizontal',
          // loop: true,
          // autoplay: autoplaySettings,
          // Disable preloading of all images
          preloadImages: false,
          // Enable lazy loading
          lazy: true,
          slidesPerView: 1.2,
          spaceBetween: 28,
          autoplay: autoplaySettings,
          observer: true,
          observeParents: true,
          parallax: true,
          on: {
            init: function () {
              element.querySelector('.shade-rt').style.display = 'block';
              element.querySelector('.shade-lft').style.display = 'none';
            },
            reachBeginning: function () {
              element.querySelector('.shade-lft').style.display = 'none';
            },
            reachEnd: function () {
              element.querySelector('.shade-rt').style.display = 'none';
            },
            slideChange: function () {
              if (swiper.activeIndex > 0) {
                element.querySelector('.shade-lft').style.display = 'block';
              }
              if (!swiper.isEnd) {
                element.querySelector('.shade-rt').style.display = 'block';
              }
            },
          },
          // Responsive breakpoints
          // Responsive breakpoints
          breakpoints: {
            300: {
              slidesPerView: 1.2,
              spaceBetween: 28,
            },
            550: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            // when window width is >= 480px
          },
          // Navigation arrows
          navigation: {
            nextEl: swiperNav.next,
            prevEl: swiperNav.prev,
          },
        });
      };
      /*********************************************************************/

      // Init swiper for each swiper element
      swiperElements.forEach((el) => {
        swiper(el);
      });
      /*********************************************************************/

      // Switch button logic
      switchButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          // Set the active button classes
          switchButtons.forEach((el) => {
            if (el === e.target) {
              e.target.classList.add('button-active');
              e.target.classList.remove('button-inactive');
            } else {
              el.classList.add('button-inactive');
              el.classList.remove('button-active');
            }
            // Switch blocks
            const buttonId = btn.getAttribute('data-id');
            // Loop through the block content
            switchBlocks.forEach((block) => {
              const blockId = block.getAttribute('data-id');
              if (blockId === buttonId) {
                // Set up classes / visibility
                block.classList.add('block-active');
                block.classList.remove('block-inactive');
              } else {
                block.classList.remove('block-active');
                block.classList.add('block-inactive');
              }
            });
          });
        });
      });
    }
  });
})();
